import { AppBar, type AppBarProps, Box, Toolbar } from '@mui/material';
import logoSecondary from 'assets/icons/logo-secondary.svg';
import { castArray } from 'lodash-es';
import type { FC } from 'react';
import {
  SimpleHeaderLogoStyle,
  SimpleHeaderLogoWrapperStyle,
  SimpleHeaderStyle,
  SimpleHeaderToolbarStyle,
} from './SimpleHeader.styles';

type SimpleHeaderProps = AppBarProps;

const SimpleHeader: FC<SimpleHeaderProps> = ({ sx }) => {
  return (
    <AppBar sx={[SimpleHeaderStyle, ...castArray(sx)]}>
      <Toolbar sx={SimpleHeaderToolbarStyle}>
        <Box sx={SimpleHeaderLogoWrapperStyle}>
          <Box component="img" src={logoSecondary} sx={SimpleHeaderLogoStyle} />
        </Box>
      </Toolbar>
    </AppBar>
  );
};

export default SimpleHeader;
